<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <router-link :to="{path:'/ExhibitionA2Detail/'+item.id}" tag="div" class="item" v-for="(item,index) in dataList" :key="index">
          <div class="pic">
            <img :src="item.picUrl" alt="">
            <div class="summary" :class="item.isShow=='展览中' || item.isShow=='Underway'?'':'on'">{{item.isShow}}</div>
            <div class="cover" :class="item.isShow=='展览中' || item.isShow=='Underway'?'':'on'"></div>
          </div>
          <div class="text">
            <div class="title">
              <div class="text-hide" style="width: 330px;">{{item.title}}</div>
              <span :style="{width:item.isNeed=='Not Free'?'82px':''}">{{item.isNeed}}</span>
            </div>
            <div class="message" v-if="$store.getters.lang=='en'">
              <span>{{item.date}}</span>
              <span class="text-hide">{{item.address}}</span>
            </div>
            <div class="message" v-else>
              <span>展期：{{item.date}}</span>
              <span>位置：{{item.address}}</span>
            </div>
          </div>
        </router-link>
        <div style="clear: both;"></div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[6, 12, 18, 24, 30]"
          :page-size="6"
          layout="total, sizes, prev, pager, next, jumper"
          :total="config.total">
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {listShowtem} from "@/api"
  // import {getExhibitionA2} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "List",
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data() {
      return {
        // 列表数据
        dataList: [],
        // 列表参数
        config: {
          name: '',
          total: 0,
          page: 1,
          limit: 6
        }
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.toGetData()
      }
    },
    created() {
      // 获取数据
      this.toGetData()
    },
    methods:{
      // 获取数据
      async toGetData() {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "sort_num",
          isAsc: "ascending"  // : "descending"  "ascending"
        }
        let {data:{rows,total}} = await listShowtem(params)

        // console.log(rows,total)

        rows.forEach( val => {
          let _stateC = "";
          let _freeC = "";
          if(this.$store.getters.lang=='en'){
            _stateC = val.bEffect=="0" ? "NotStarted" : val.bEffect=="1"?"Underway" :val.bEffect=="2"?'Finished' :''
            _freeC = val.bFree=="0" ? "Free" : val.bFree=="1"?"Not Free" :''
          }else{
            _stateC = val.bEffect=="0" ? "未开始" : val.bEffect=="1"?"展览中" :val.bEffect=="2"?'已结束' :''
            _freeC = val.bFree=="0" ? "免费" : val.bFree=="1"?"收费" :''
          }
          this.dataList.push({
            id : val.id,
            title : this.$store.getters.lang=='en'?val.showtemTitleEn:val.showtemTitle,
            date : this.$store.getters.lang=='en'?'Long-term':'长期',
            address : this.$store.getters.lang=='en'?val.showtemAddressEn:val.showtemAddress,
            isShow : _stateC,
            picUrl : this.$store.getters.urlApi + val.showtemFace,
            isNeed : _freeC,
          })
        })
        this.config.total = total
      },
      // toGetData() {
      //   getExhibitionA2(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      // 分页事件
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6 !important;
  }

  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }

  .container {
    .wrap {
      width: 1440px;
      margin: 0 auto;
      overflow: hidden;
      padding-bottom: 140px;

      .item {
        width: 440px;
        height: 422px;
        margin: 0 30px 30px;
        background: #FFFFFF;
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
        float: left;
        cursor: pointer;

        .pic {
          width: 100%;
          height: 270px;
          position: relative;
          img{
            width: 100%;
            height: 270px;
          }
          .cover{
            display: none;
            width: 100%;
            height: 270px;
            position: absolute;
            top:0;
            left: 0;
            background: rgba(0,0,0,.6);
          }
          .cover.on{
            display: block;
          }
          .summary {
            z-index: 8;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 175px;
            height: 46px;
            line-height: 46px;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            padding-right: 20px;
            background: url('https://www.cwmuseum.cn/img/Exhibition08@2x.png')
          }
          .summary.on{
            background: url('https://www.cwmuseum.cn/img/Exhibition08_active@2x.png')
          }
        }

        .text {
          padding: 24px 28px 0;

          .title {
            font-family: PingFangSC;
            font-weight: 600;
            font-size: 28px;
            color: #333333;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span{
              width: 54px;
              height: 24px;
              line-height: 24px;
              background: #C60300;
              border-radius: 4px;
              font-family: Source Han Sans CN;
              font-size: 16px;
              color: #FFFFFF;
              display: block;
              text-align: center;
            }
          }

          .message {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 20px;
            color: #888888;
            margin-top: 18px;
            display: flex;
            flex-direction: column;
            span:nth-of-type(2){
              margin-top: 18px;
            }
          }
        }
      }

      .item:nth-of-type(3n-1) {
        margin: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Exhibition/A2/List.vue